/**
 * Created by rickborst on 12/06/2017.
 */

import _ from 'lodash';

import Navigation from 'models/navigation';

const topNavigationItems = [
        {
            name: 'guide',
            label: 'navigation.guide',
            route: 'guide'
        },
        {
            name: 'catchup',
            label: 'navigation.catch-up',
            route: 'catchup'
        },
        {
            name: 'discover',
            label: 'navigation.discover',
            route: 'discover/discover-sport-5'
        }
    ];

/**
 * Returns the top navigation items.
 *
 * @returns {Promise} Top navigation promise.
 */
export function getTopNavigation () {
    let items = _.map(topNavigationItems, item => {

        return new Navigation(item);
    });

    return Promise.resolve(items);
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/navigation.js